import altadecontenido from "./altadecontenido/altadecontenido"
import paginaoficial from "./paginaoficial/paginaoficial"
import ediciondecontenido from "./ediciondecontenido/ediciondecontenido"
import administracionDeSubmenus from "./administracionDeSubmenus/administracionDeSubmenus"
import administracionDeMenus from "./administracionDeMenus/administracionDeMenus"
import busquedadedocumentos from "./busquedaDeDocumentos/busquedadedocumentos"
import permisos from "./permisos/permisos"
import convocatorias from "./convocatoriasWeb/convocatoriasWeb"

const paginaweb = {
    altadecontenido: altadecontenido,
    ediciondecontenido: ediciondecontenido,
    paginaoficial: paginaoficial,
    administracionDeSubmenus: administracionDeSubmenus,
    administracionDeMenus: administracionDeMenus,
    busquedadedocumentos: busquedadedocumentos,
    permisos: permisos,
    convocatoriasWeb:convocatorias
}

export default paginaweb;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/paginaweb.js
// module id = null
// module chunks = 